import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-contact',
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './contact.html',
  styleUrl: './contact.css'
})
export class Contact implements OnInit {
  formData = {
    name: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  };

  subjects = [
    'General Inquiry',
    'Project Consultation',
    'Partnership Opportunity',
    'Career Inquiry',
    'Support Request',
    'Other'
  ];

  contactInfo = [
    {
      icon: 'email',
      title: 'Email Us',
      value: 'info@honeykode.com',
      description: 'We\'ll respond within 24 hours'
    },
    {
      icon: 'phone',
      title: 'Call Us',
      value: '+91 7593898889',
      description: 'Mon-Fri from 9am to 6pm'
    },
    {
      icon: 'location',
      title: 'Visit Us',
      value: '6th Floor, Bhavani, Technopark',
      description: 'Trivandrum, Kerala, India - 695581'
    }
  ];

  isSubmitting = false;
  submitSuccess = false;

  // CAPTCHA
  captchaNum1 = 0;
  captchaNum2 = 0;
  captchaAnswer = '';
  captchaError = false;

  // Consent
  consentChecked = false;

  ngOnInit() {
    this.generateCaptcha();
  }

  generateCaptcha() {
    this.captchaNum1 = Math.floor(Math.random() * 10) + 1;
    this.captchaNum2 = Math.floor(Math.random() * 10) + 1;
    this.captchaAnswer = '';
    this.captchaError = false;
  }

  validateCaptcha(): boolean {
    const correctAnswer = this.captchaNum1 + this.captchaNum2;
    return parseInt(this.captchaAnswer) === correctAnswer;
  }

  onSubmit() {
    // Validate CAPTCHA
    if (!this.validateCaptcha()) {
      this.captchaError = true;
      this.generateCaptcha();
      return;
    }

    // Validate consent
    if (!this.consentChecked) {
      return;
    }

    this.isSubmitting = true;
    // Simulate API call
    setTimeout(() => {
      this.isSubmitting = false;
      this.submitSuccess = true;
      this.resetForm();
    }, 1500);
  }

  resetForm() {
    this.formData = {
      name: '',
      email: '',
      phone: '',
      company: '',
      subject: '',
      message: ''
    };
    this.captchaAnswer = '';
    this.consentChecked = false;
    this.generateCaptcha();
  }
}
